<template>
  <PanelContent
    class="frequently-asked-questions-item-content"
    item-scope
    item-prop="acceptedAnswer"
    item-type="https://schema.org/Answer"
    text-item-type="text"
  >
    <slot />
  </PanelContent>
</template>

<script lang="ts" setup>
  import PanelContent from '@/shared/ui/expansionPanels/PanelContent.vue';

  defineSlots<{
    /**
     * Content.
     */
    default(): unknown;
  }>();
</script>
